<template>
  <div class="buyerDetail">
    <div class="top">
      <div>
        <span
          class="van-ellipsis"
          style="display:block;max-width:4rem"
        >{{baseData.id != 1?baseData.name:'临时客户'}}</span>
        <span>
          <van-icon v-if="baseData.id != 1" name="edit" size="0.4rem" @click="toUpdate" />
        </span>
      </div>
      <div v-show="baseData.id != 1">{{baseData.mobile}}</div>
    </div>
    <div class="center" v-if="baseData.id != 1">
      <a
        :href="'sms:'+baseData.mobile+'?'+ '您好，您还有'+baseData.need_repayment_amount+'元欠款未还清，请尽快处理！'"
        v-if="!isApp"
      >
        <img src="../../../../assets/img/work/manage/message_z.png" alt />短信催收
      </a>
      <span v-else @click="sendMessage(baseData.mobile,baseData.need_repayment_amount)">
        <img src="../../../../assets/img/work/manage/message_z.png" alt />短信催收
      </span>
      <span @click="toCredit">
        <img src="../../../../assets/img/work/manage/gopay_z.png" alt />还款
      </span>
    </div>
    <van-cell center title="买家状态" style="margin-bottom:0.1rem" v-if="baseData.id != 1">
      <template #right-icon>
        <van-switch
          v-model="checked"
          active-value="1"
          inactive-value="0"
          size="24"
          :loading="loading"
          active-color="#31B158"
          @change="handleChange"
        />
      </template>
    </van-cell>
    <div class="search_box">
      <!-- <div>
            <input type="text" placeholder="输入商品名" v-model="listQuery_2.name" />
            <van-icon @click="listQuery_2.name=''" v-if="listQuery_2.name" name="close" style="margin-left:0.1rem" />
      </div>-->
      <div @click="showCalendar=true" v-if="listQuery_2.from_time">
        <span>{{this.listQuery_2.from_time |toDate}}-{{this.listQuery_2.to_time | toDate}}</span>
        <van-icon name="arrow-down" style="margin-left:0.1rem" />
      </div>
      <div @click="showCalendar=true" v-else>
        <span>点击选择时间</span>
        <van-icon name="arrow-down" style="margin-left:0.1rem;margin-top:0.06rem" />
      </div>
    </div>
    <van-tabs
      v-model="active"
      color="#31b158"
      title-active-color="#31b158"
      title-inactive-color="#4D4D4D"
      class="tabs_box"
    >
      <van-tab title="业务信息">
        <div class="content">
          <div>
            <span>采购金额</span>：
            <span>{{Number(baseData.receivables_total).toFixed(2)}}元</span>
          </div>
          <div>
            <span>采购单数</span>：
            <span>{{baseData.order_count ||0}}单</span>
          </div>
          <div v-if="baseData.id != 1">
            <span>未还欠款</span>：
            <span>{{Number(baseData.need_repayment_amount).toFixed(2)}}元</span>
          </div>
          <!-- v-if="baseData.surcharge" -->
          <div class="surcharge">
            <div>附加费：</div>
            <div>
              <!-- -->
              <div v-for="(item,i) in baseData.surcharge" :key="i">
                <span>{{item.name}}</span>
                <span>{{Number(item.num).toFixed(0)}}个</span>
              </div>
            </div>
            <div v-if="baseData.surcharge.length==0" style="color:#666">暂无附加费</div>
          </div>
        </div>
      </van-tab>
      <van-tab title="采购详情">
        <div class="title">
          <span>
            <van-dropdown-menu active-color="#31b158">
              <van-dropdown-item
                v-model="listQuery_2.status"
                :options="option1"
                title-class="item"
                @change="changeList_2"
              />
            </van-dropdown-menu>
          </span>
          <span>
            采购总金额：
            <em>{{Number(receivables_total).toFixed(2)}}元</em>
          </span>
        </div>

        <div class="list">
          <van-list
            v-model="loading_2"
            :finished="finished_2"
            finished-text="没有更多了"
            @load="getList_2"
          >
            <div
              class="c-content"
              v-for="(citem,cindex) in list_2"
              :key="cindex"
              @click="jumpOrderDetail(citem.order_sn)"
            >
              <div class="c-title">
                <span>订单编号：{{citem.order_sn}}</span>
                <span v-if="citem.status!=2">{{option1[citem.status].text}}</span>
                <span
                  v-if="citem.status==2 && citem.need_repayment_amount == citem.receivables"
                >整单赊欠</span>
                <span
                  v-if="citem.status==2 && citem.need_repayment_amount != citem.receivables"
                >部分赊欠</span>
              </div>
              <div class="c-info">
                <span class="van-ellipsis">{{citem.buyer_name}}</span>
                <span class="flex_wrop">¥ {{Number(citem.receivables).toFixed(2)}}</span>
              </div>
              <div class="c-name van-ellipsis">
                <span v-for="(item_good,index_good) in citem.goods" :key="index_good">
                  <i v-if="index_good>0">、</i>
                  {{item_good.name}}
                </span>
              </div>
              <div class="c-date">收银时间：{{ citem.create_time | toTime}}</div>
            </div>
            <div style="height:0.5rem"></div>
          </van-list>
        </div>
      </van-tab>
      <van-tab title="还款详情" v-if="baseData.id != 1">
        <div class="list">
          <van-collapse v-model="activeNames">
            <van-list
              v-model="loading_3"
              :finished="finished_3"
              finished-text="没有更多了"
              @load="getList_3"
            >
              <van-collapse-item
                v-for="(citem,cindex) in list_3"
                :key="cindex"
                :name="String (cindex+1)"
                style="margin-bottom:0.2rem;"
              >
                <template #title>
                  <div class="d-title">
                    <span>还款金额</span>
                    <span>{{Number(citem.repayment).toFixed(2)}}元</span>
                  </div>
                  <div class="d-title">
                    <span>还款时间</span>
                    <span>{{ citem.create_time | toTime}}</span>
                  </div>
                </template>
                <div class="d-content" v-if="citem.is_history != 1">
                  <div>
                    <span>订单编号：{{citem.order_sn}}</span>
                    <!-- <span>{{option1[citem.order_status].text}}</span>   -->
                    <span v-if="citem.order_status!=2">{{option2[citem.order_status].text}}</span>
                    <span
                      v-if="citem.order_status==2 && citem.need_repayment_amount == citem.receivables"
                    >整单赊欠</span>
                    <span
                      v-if="citem.order_status==2 && citem.need_repayment_amount != citem.receivables"
                    >部分赊欠</span>
                  </div>
                  <div class="d-name">
                    <span class="van-ellipsis">{{citem.buyer_name}}</span>
                    <span class="flex_wrop">¥ {{Number(citem.order_receivables).toFixed(2)}}</span>
                  </div>
                  <div class="d-info">
                    <span v-for="(item_good,index_good) in citem.goods" :key="index_good">
                      <i v-if="index_good>0">、</i>
                      {{item_good.name}}
                    </span>
                  </div>
                  <div class="d-date">收银时间：{{ citem.order_create_time | toTime}}</div>
                </div>
                <div v-else>订单补录还款记录，无订单信息</div>
              </van-collapse-item>
              <div style="height:0.5rem"></div>
            </van-list>
          </van-collapse>
        </div>
      </van-tab>
      <van-tab title="商品统计" v-if="baseData.id != 1">
        <!-- <div v-if="num_total >0">
          <div class="history_item">
            欠款总金额：
            <span class="num">{{num_total}}</span>元
          </div>
          <div class="history_item" v-if="need_repayment_amount_total>0">
            待还总金额：
            <span class="num">{{need_repayment_amount_total}}</span>元
          </div>
        </div>-->
        <div class="goods_acount">
          <div class="listBox" v-if="list_4.length>0">
            <div class="list" v-for="(g_items,i) in list_4" :key="i">
              <div class="g_name">
                <div>{{g_items.name}}</div>
                <div>{{g_items.order_num}}单</div>
              </div>
              <div>
                <div class="g_num">
                  <div>
                    <span
                      v-if="g_items.bale!=3"
                    >{{Number(g_items.num).toFixed(2)}}{{unit_list[0].name}}</span>
                    <span v-if="g_items.weight">{{Number(g_items.weight).toFixed(2)}}公斤</span>
                  </div>
                  <div>销量</div>
                </div>
                <div class="g_money">
                  <div>{{g_items.payment}}</div>
                  <div>金额(元)</div>
                </div>
              </div>
              <div class="line"></div>
            </div>

            <!-- <div class="history_item" v-for="(citem,cindex) in list_4" :key="cindex">
              <div>
                <span
                  style="font-size:0.32rem;font-weight:bold;"
                  class="van-ellipsis"
                >{{citem.buyer_name}}</span>
                <span v-if="citem.status == 1" class="flex_wrop">已还款</span>
                <span v-if="citem.status == 0" class="flex_wrop">待还款</span>
              </div>
              <div>
                <span>
                  赊账金额：
                  <span class="num">{{citem.num}}</span>元
                </span>
              </div>
              <div v-if="citem.status == 0">
                <span>
                  待还金额：
                  <span class="num">{{citem.need_repayment_amount}}</span>元
                </span>
              </div>
              <div>
                <span>录入时间：{{citem.credit_time | toTime}}</span>
              </div>
            </div>-->
          </div>
          <div v-else class="zanwu">暂无数据</div>
        </div>

        <!--  -->
      </van-tab>
    </van-tabs>
    <!-- 时间选择 -->
    <van-calendar
      v-model="showCalendar"
      type="range"
      color="#07c160"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onConfirmDate"
      :default-date="default_date"
      :allow-same-day="true"
    />
  </div>
</template>

<script>
import {
  buyer_detail_base,
  buyer_detail_order,
  buyer_detail_repayment,
  buyer_history_repayment,
  buyer_update,
  buyer_create,
  buyer_goods_acount,
} from "@/api/work/manage/buyer";
import {
  timestampToTime,
  timestampToDateNewDate,
  timestampToDate,
} from "@/utils/timestamp";
export default {
  name: "buyerDetail",
  filters: {
    toTime(t) {
      return timestampToTime(t);
    },
    toDate(t) {
      return timestampToDateNewDate(t);
    },
  },
  data() {
    return {
      id: "",
      active: "",
      value1: 0,
      searchGoodsName: "",
      showCalendar: false,
      minDate: new Date("2010/01/01"),
      maxDate: new Date(),
      default_date: [
        new Date(),
        new Date(timestampToDateNewDate(new Date().getTime() / 1000 - 1)),
      ],
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" },
      ],
      option1: [
        { text: "全部订单", value: "" },
        { text: "已结清", value: "1" },
        { text: "赊欠", value: "2" },
        // { text: "作废", value: "3" },
        // { text: "改单", value: "4" }
      ],
      option2: [
        { text: "全部订单", value: "" },
        { text: "已结清", value: "1" },
        { text: "赊欠", value: "2" },
        { text: "作废", value: "3" },
        { text: "改单", value: "4" },
      ],
      activeNames: ["1"],
      sms: "",

      baseData: {
        id: "",
        name: "",
        mobile: "",
        car_no: "",
        remark: "",
        need_repayment_amount: "590.00",
        order_count: 1,
        receivables_total: "0.00",
        surcharge: [],
      },

      list_2: [],
      loading_2: true,
      finished_2: true,
      listQuery_2: {
        buyer_id: "",
        page: 1,
        pageSize: "4",
        status: "", // [1结清; 2赊欠; 3作废; 4改单]
        // name: "",
        from_time: "",
        to_time: "",
      },
      receivables_total: 0,

      list_3: [],
      loading_3: true,
      finished_3: true,
      listQuery_3: {
        buyer_id: "",
        page: 1,
        pageSize: "4",
      },

      list_4: [],
      loading_4: true,
      finished_4: true,
      listQuery_4: {
        buyer_id: "",
      },
      num_total: "",

      checked: "0",
      loading: false,
      isApp: window.plus ? true : false,
    };
  },
  created() {
    this.baseData.id = this.$route.query.id;
    this.listQuery_2.buyer_id = this.$route.query.id;
    this.listQuery_3.buyer_id = this.$route.query.id;
    this.listQuery_4.buyer_id = this.$route.query.id;
    this.getData();
    this.getList_2();
    this.getList_3();
    this.getList_4();

    this.$navigation.on("back", (to, from) => {
      if (to.route.name == "manage_buyer_buyerDetail") {
        this.listQuery_2.page = 1;
        this.listQuery_3.page = 1;
        this.getData();
        this.getList_2();
        this.getList_3();
        this.getList_4();
      }
    });
  },
  mounted() {},
  methods: {
    //时间选择
    onConfirmDate(date) {
      this.listQuery_2.page = 1;
      this.list_2 = [];
      // this.default_date[0] = timestampToDateNewDate(
      //   new Date(date[0]).getTime() / 1000
      // );
      // this.default_date[1] = timestampToDateNewDate(
      //   new Date(date[1]).getTime() / 1000 + 86400 - 1
      // );
      this.listQuery_2.from_time =
        new Date(
          timestampToDateNewDate(new Date(date[0]).getTime() / 1000)
        ).getTime() / 1000;
      this.listQuery_2.to_time =
        new Date(
          timestampToDateNewDate(new Date(date[1]).getTime() / 1000)
        ).getTime() /
          1000 +
        60 * 24 * 60 -
        1;
      this.getData();
      this.getList_2();
      this.getList_4();
      this.showCalendar = false;
    },
    // 获取数据 业务信息
    getData() {
      let obj = {
        id: this.baseData.id,
        from_time: this.listQuery_2.from_time, //this.listQuery_2.from_time,
        to_time: this.listQuery_2.to_time, //this.listQuery_2.to_time
      };
      console.log("", obj);
      buyer_detail_base(obj).then((res) => {
        if (res.code == 200) {
          var data = res.data;
          this.checked = data.status + "";
          this.baseData.name = data.name;
          this.baseData.mobile = data.mobile;
          this.baseData.car_no = data.car_no;
          this.baseData.remark = data.remark;
          this.baseData.need_repayment_amount = data.need_repayment_amount;
          this.baseData.order_count = data.order_count;
          this.baseData.receivables_total = data.receivables_total;
          this.baseData.surcharge = data.surcharge;
        }
      });
    },
    // 获取列表 采购详情
    getList_2() {
      buyer_detail_order(this.listQuery_2).then((res) => {
        if (res.code == 200) {
          this.receivables_total = res.data.receivables_total;
          if (this.listQuery_2.page == 1) this.list_2 = [];
          this.list_2 = this.list_2.concat(res.data.list);
          if (
            this.list_2.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.finished_2 = true;
          } else {
            this.finished_2 = false;
            this.loading_2 = false;
            this.listQuery_2.page++;
          }
        }
      });
    },
    // 下拉菜单选择
    changeList_2() {
      this.listQuery_2.page = 1;
      this.getList_2();
    },

    // 获取列表 还款详情
    getList_3() {
      buyer_detail_repayment(this.listQuery_3).then((res) => {
        if (res.code == 200) {
          if (this.listQuery_3.page == 1) this.list_3 = [];
          this.list_3 = this.list_3.concat(res.data.list);
          if (
            this.list_3.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.finished_3 = true;
          } else {
            this.finished_3 = false;
            this.loading_3 = false;
            this.listQuery_3.page++;
          }
        }
      });
    },

    // 获取列表
    getList_4() {
      let params = {
        buyer_id: this.listQuery_4.buyer_id,
        from_time: this.listQuery_2.from_time,
        to_time: this.listQuery_2.to_time,
      };
      buyer_goods_acount(params).then((res) => {
        if (res.code == 200) {
          this.list_4 = res.data;
          this.finished_3 = true;
        }
      });
    },

    toCredit() {
      this.$router.push({
        path: "/credit/fastPayment",
        query: {
          id: this.baseData.id,
        },
      });
    },

    // 修改状态
    handleChange(status) {
      this.loading = true;
      buyer_update({ id: this.baseData.id, status }).then((res) => {
        if (res.code == 200) {
          this.loading = false;
          this.getData();
          // this.$toast.success(res.message);
        }
      });
    },

    jumpOrderDetail(order) {
      this.$router.push({
        path: "/manage/order/orderDetail",
        query: {
          order_sn: order,
        },
      });
    },

    //
    toUpdate() {
      this.$router.push({
        path: "/manage/buyer/addBuyer",
        query: {
          id: this.$route.query.id,
        },
      });
    },

    // send message

    sendMessage(phone, message) {
      var msg = plus.messaging.createMessage(plus.messaging.TYPE_SMS);
      msg.to = [phone];
      msg.body = "您好，您还有" + message + "元欠款未还清，请尽快处理！";
      plus.messaging.sendMessage(msg);
    },
  },
};
</script>

<style lang="less" scoped>
.buyerDetail {
  font-size: 0.32rem;
  .top {
    width: 100%;
    height: 2.74rem;
    background: url("../../../../assets/img/work/manage/buyerDetail_bg.png")
      no-repeat center;
    background-size: 100% 100%;
    color: #fff;
    padding-left: 0.31rem;
    box-sizing: border-box;
    overflow: hidden;
    .van-icon {
      margin-left: 0.58rem;
      vertical-align: sub;
      font-weight: 600;
    }
    > div:first-child {
      margin-top: 0.7rem;
      margin-bottom: 0.29rem;
      font-size: 0.36rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    > div:last-child {
      font-size: 0.24rem;
    }
  }
  .center {
    width: 6.9rem;
    margin: -0.77rem auto 0.2rem;
    border-radius: 0.16rem;
    background-color: #fff;
    line-height: 0.8rem;
    padding: 0.2rem 0;
    span,
    a {
      box-sizing: border-box;
      display: inline-block;
      width: 50%;
      text-align: center;
      color: #4e4e4e;
      img {
        width: 0.48rem;
        height: 0.48rem;
        margin-right: 0.21rem;
        vertical-align: middle;
      }
    }
    > span:first-child {
      border-right: 0.01rem solid #e6e6e6;
    }
  }
  .content {
    margin-top: 0.2rem;
    background-color: #fff;
    padding: 0 0.3rem;
    > div {
      line-height: 0.87rem;
      color: #333333;
      > span:first-of-type {
        color: #7e7e7e;
      }
    }
    > div:not(:last-child) {
      border-bottom: 0.01rem solid #e5e5e5;
    }
    .surcharge {
      display: flex;
      line-height: 0.5rem;
      padding-top: 0.12rem;
      padding-bottom: 0.12rem;
      > div:nth-of-type(1) {
        margin-right: 0.32rem;
        color: #7e7e7e;
      }
      > div:nth-of-type(2) {
        display: flex;
        flex-direction: column;

        > div {
          display: flex;
          align-items: center;
        }
        span:nth-of-type(1) {
          display: block;
          width: 2rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        span:nth-of-type(2) {
          margin-left: 0.06rem;
        }
      }
    }
  }
  .title {
    display: flex;
    background-color: #fff;
    > span {
      width: 50%;
      // .van-dropdown-menu {
      //   height: 0.6rem;
      // }
    }
    > span:last-child {
      font-size: 0.28rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #7e7e7e;
      text-align: right;
      padding-right: 0.2rem;
      line-height: 0.6rem;
      em {
        color: #f76900;
      }
    }
  }
  .flex_wrop {
    flex-shrink: 0;
    flex-wrap: nowrap;
  }
  .c-content {
    margin-top: 0.2rem;
    background-color: #fff;
    padding: 0 0.2rem;
    color: #262626;
    .c-title {
      display: flex;
      justify-content: space-between;
      font-size: 0.3rem;

      border-bottom: 0.01rem solid #f2f2f2;
      padding: 0.2rem 0;
    }
    .c-info {
      display: flex;
      justify-content: space-between;
      font-size: 0.36rem;
      margin: 0.09rem 0 0;
    }

    .c-name {
      font-size: 0.3rem;
      padding: 0.1rem 0;
    }
    .c-date {
      font-size: 0.28rem;
      color: #989898;
      padding: 0.1rem 0;
      margin-bottom: 0.2rem;
    }
  }
  .d-title {
    font-size: 0.32rem;
    > span:first-child {
      color: #7e7e7e;
      margin-right: 0.48rem;
    }
    > span:first-child {
      color: #333333;
    }
  }
  .d-content {
    font-size: 0.3rem;
    color: #333333;
    > div:first-child {
      display: flex;
      justify-content: space-between;
      border-bottom: 0.01rem #e5e5e5 solid;
      padding-bottom: 0.2rem;
    }
    .d-name {
      display: flex;
      justify-content: space-between;
      margin-top: 0.1rem;
      line-height: 0.54rem;
      > span:first-child {
        font-size: 0.36rem;
      }
    }
    .d-info {
      font-size: 0.32rem;
      line-height: 0.51rem;
    }
    .d-date {
      font-size: 0.28rem;
      color: #989898;
      margin-top: 0.1rem;
    }
  }
  .history_item {
    width: 100%;
    background-color: #fff;
    margin-bottom: 0.2rem;
    box-sizing: border-box;
    padding: 0.2rem 0.3rem;
    font-size: 0.28rem;
    .num {
      color: #f00;
    }
    & > div {
      line-height: 0.5rem;
      &:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }

  .search_box {
    padding: 0.2rem 0.2rem;
    margin-top: 0.2rem;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // input {
    //   padding: 0 0.1rem;
    //   height: 0.6rem;
    //   color: #333;
    //   width: 2.4rem;
    //   line-height: 0.58rem;
    //   border-radius: 0.06rem;
    // }
    // div:nth-of-type(1){
    //   display: flex;
    //   width: 2.8rem;
    //   border: 0.01rem solid #ccc;
    // }
    div:nth-of-type(1) {
      width: 4.2rem;
      border: 0.01rem solid #ccc;
      padding: 0.1rem;
      border-radius: 0.06rem;
      display: flex;
      justify-content: center;
    }
  }
  .goods_acount {
    margin-top: 0.2rem;
    padding: 0 0.24rem;
    padding-bottom: 0.2rem;
    background: #fff;
    .zanwu {
      text-align: center;
      color: #999;
      padding-top: 0.2rem;
    }
    .listBox {
      .list {
        color: #333;
        font-size: 0.24rem;
        padding-top: 0.2rem;
        > div:nth-of-type(1) {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.28rem;
          > div:nth-of-type(1) {
            font-size: 0.3rem;
            font-weight: bold;
          }
        }
        > div:nth-of-type(2) {
          display: flex;
          justify-content: space-around;
          padding-bottom: 0.2rem;
          font-size: 0.28rem;
          > div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            > div:nth-of-type(1) {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 0.8rem;
            }

            > div:nth-of-type(2) {
              color: #666;
              font-size: 0.24rem;
            }
          }
        }
        .line {
          width: 100%;
          height: 0.01rem;
          background: #e5e5e5;
        }
      }
    }
  }
}
</style>

<style lang="less">
.buyerDetail {
  .tabs_box {
    .van-tabs__wrap {
      position: sticky;
      top: 0.88rem;
      z-index: 3;
    }
    .van-tab {
      font-size: 0.32rem;
    }
    .van-tab__pane{
      min-height:calc(100vh - 0.88rem - 44px) ;
      background: #fff;
    }
  }
}
</style>